import { render, staticRenderFns } from "./RelatoriosTable.vue?vue&type=template&id=f7570d0a&"
import script from "./RelatoriosTable.vue?vue&type=script&lang=js&"
export * from "./RelatoriosTable.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosTable.vue?vue&type=style&index=0&id=f7570d0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports